import { createSlice } from '@reduxjs/toolkit';
import { resolveDefaultEnvironmentConfig, } from '../config/environment';
const defaultEnvironment = resolveDefaultEnvironmentConfig();
const initialState = {
    userToken: undefined,
    refreshToken: undefined,
    tokenExpires: undefined,
    email: '',
    selectedUserId: undefined,
    loading: false,
    success: false,
    environment: defaultEnvironment.environment,
    backendBaseUrl: defaultEnvironment.backendBaseUrl,
    frontendBaseUrl: defaultEnvironment.frontendBaseUrl,
    portionClarityToastMessage: undefined,
};
export const emailSelector = (state) => state.app.email;
export const selectedUserIdSelector = (state) => state.app.selectedUserId;
export const userTokenSelector = (state) => state.app.userToken;
export const backendBaseUrlSelector = (state) => state.app.backendBaseUrl;
export const frontendBaseUrlSelector = (state) => state.app.frontendBaseUrl;
export const environmentSelector = (state) => state.app.environment;
export const portionClarityToastMessageSelector = (state) => state.app.portionClarityToastMessage;
export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setEmail(state, action) {
            state.email = action.payload;
        },
        setSelectedUserId(state, action) {
            state.selectedUserId = action.payload;
        },
        signout: state => {
            state.userToken = undefined;
            state.refreshToken = undefined;
            state.tokenExpires = undefined;
            state.selectedUserId = undefined;
            state.portionClarityToastMessage = undefined;
        },
        showPortionClarityToast(state, action) {
            state.portionClarityToastMessage = action.payload;
        },
        clearPortionClarityToast(state) {
            state.portionClarityToastMessage = undefined;
        },
        // Update setCredentials to only accept token, refreshToken, and tokenExpires.
        setCredentials: (state, action) => {
            state.userToken = action.payload.token;
            state.refreshToken = action.payload.refreshToken;
            state.tokenExpires = action.payload.tokenExpires;
        },
        setForcedSignoutVersion(state, action) {
            state.forcedSignoutVersion = action.payload;
        },
        setEnvironmentConfig: (state, action) => {
            state.environment = action.payload.environment;
            state.backendBaseUrl = action.payload.backendBaseUrl;
            state.frontendBaseUrl = action.payload.frontendBaseUrl;
        },
    },
});
export const { setEmail, setSelectedUserId, signout, setCredentials, setEnvironmentConfig, setForcedSignoutVersion, showPortionClarityToast, clearPortionClarityToast, } = appSlice.actions;
export default appSlice.reducer;
